import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { CoordinateDiagnosis } from '../../../shared/model/coordinate-diagnosis';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { DiagnosisService } from '../../service/diagnosis.service';
import { ToastService } from '../../../shared/service/toast.service';
import { DiagnosisItemStatus } from '../../model/diagnosis-item-status';
import { CanParam } from '../../model/can-param';

@Component({
    selector: 'tx-can-diagnosis',
    templateUrl: './can-diagnosis.component.html',
    styleUrls: ['./can-diagnosis.component.css']
  })
export class CanDiagnosisComponent implements OnInit {
  _coordinateDiagnosis: CoordinateDiagnosis;
  running = true;
  _run: boolean;
  canParams: Array<CanParam>;
  coordinateCanParams: any;
  canEnabledAttribute = "Ativação da CAN";
  hasError = false;
  errorType: String;
  trnRsnIds: Array<Number>;

  constructor(private _diagnosisNotification: DiagnosisWebSocketService,
              private _diagnosiService: DiagnosisService,
              private _toastService: ToastService) {
  }
  
  ngOnInit() {
    if (this._run) {
      this.observeRestart();
      this.observeBack();
      this.setEmptyEntities();
      this.subscribeRunning();
      this.subscribeSuccess();
      this.subscribeFail();
      this.subscribeTimeout();
      this.subscribeError();
    } else {
      this.displayViewMode();
    }
  }

  @Input()
  set run(run) {
    this._run = run;
  }

  get run() {
    return this._run;
  }

  canWasEnabled() {
    let enabled = false;
    this.canParams.forEach((element) => {
      if (element.attribute === this.canEnabledAttribute) {
        enabled = element.status === DiagnosisItemStatus.SUCCESS;
      }
    });
    return enabled;
  }

  hasCanActivationTimeout() {
    let has = true;
    this.canParams.forEach((element) => {
      if (element.attribute === this.canEnabledAttribute) {
        has = element.status === DiagnosisItemStatus.RUNNING;
      }
    });
    return has;
  }

  displayViewMode() {
    // TODO display view mode for future attending diagnosis
  }

  observeRestart() {
    this._diagnosisNotification.restart$
      .subscribe(() => {
        this.setEmptyEntities();
        this.running = true;
        this.hasError = false;
      });
  }

  observeBack() {
    this._diagnosisNotification.back$
      .subscribe(() => {
        this.setEmptyEntities();
        this.running = false;
        this.hasError = false;
      });
  }

  setEmptyEntities() {
    this.canParams = [];
    this.coordinateCanParams = {};
    this.errorType = undefined;
    this.trnRsnIds = [];
  }

  subscribeSuccess() {
    this._diagnosisNotification.success$
      .filter(data => data instanceof CoordinateDiagnosis)
      .subscribe(coordinateDiagnosis => {
        this.setAttributeState(coordinateDiagnosis, DiagnosisItemStatus.SUCCESS);
        this.updateDiagnosisDisplay(coordinateDiagnosis);
      });
  }

  subscribeFail() {
    this._diagnosisNotification.failed$
      .filter(data => data instanceof CoordinateDiagnosis)
      .subscribe(coordinateDiagnosis => {
        this.setAttributeState(coordinateDiagnosis, DiagnosisItemStatus.FAILED);
        this.updateDiagnosisDisplay(coordinateDiagnosis);
      });
  }

  subscribeRunning() {
    this._diagnosisNotification.running$
      .filter(data => data instanceof CoordinateDiagnosis)
      .subscribe(coordinateDiagnosis => {
        this.setAttributesToRunning(coordinateDiagnosis);
        this.updateDiagnosisDisplay(coordinateDiagnosis);
      });
  }

  subscribeTimeout() {
    this._diagnosisNotification.timeout$
      .filter(data => data instanceof CoordinateDiagnosis)
      .subscribe(coordinateDiagnosis => {
        this.trnRsnIds = coordinateDiagnosis.trnRsnIds;
        this.setAttributeState(coordinateDiagnosis, DiagnosisItemStatus.TIMEOUT);
        this.updateDiagnosisDisplay(coordinateDiagnosis);
      });
  }

  restartDiagnosis() {
    this._diagnosisNotification.restart();
    this.running = true;
    this.hasError = false;
  }

  subscribeError() {
    this._diagnosisNotification.error$
      .subscribe((data) => {
        this.setEmptyEntities();
        this.running = false;
        this.hasError = true;
        this.errorType = data.error;
      });
  }

  private setAttributeState(coordinateResponse, status) {
    Object.keys(coordinateResponse.canParams).forEach(key => {
      if (!(key in this.coordinateCanParams)) {
        this.updateCanParamStatus(key, coordinateResponse.canParams[key], status);
      }
    });
  }

  private updateCanParamStatus(attribute, value, status) {
    this.canParams.forEach((element) => {
      if (element.attribute === attribute) {
        element.status = status;
        element.value = value;
        this.coordinateCanParams[attribute] = status;
      }
    });
  }

  private setAttributesToRunning(coordinateResponse) {
    this.canParams = [];
    Object.keys(coordinateResponse.canParams).forEach(key => {
      this.canParams.push(<CanParam>({
        attribute: key,
        value: coordinateResponse.canParams[key],
        status: DiagnosisItemStatus.RUNNING
     }));
    });
  }

  private updateDiagnosisDisplay(coordinateResponse) {
    this.running = coordinateResponse.isRunning;
  }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/can-diagnosis/can-diagnosis.component.ts